import { getAuthModule, type LogoutReason } from '@littlebird/auth-client';
import { captureException } from '@sentry/react';
import { toast } from 'sonner';

import { AppCapability, isCapable } from './capabilities';

export type { LogoutReason };

export async function logoutUser(reason: LogoutReason = 'manual') {
  if (!isCapable(AppCapability.MainWindowExclusive))
    throw new Error(
      'logout user can only be called in the main window or in a browser window'
    );

  console.info(`[Auth] Logging out user. Reason: ${reason}`);

  try {
    const auth = getAuthModule();
    // Auth module will emit AUTH_LOGOUT event which triggers cleanup in auth listeners
    await auth.logout(reason);
  } catch (error) {
    captureException(error);
    toast.error('Error during logout', {
      description: (error as Error)?.message,
    });
  }
}
